import { FC } from "react";
import ReportWebLayout from "./WebLayout";

const Report: FC = () => {
  return (
    <div>
      <ReportWebLayout />
    </div>
  );
};

export default Report;
